import React, { useContext } from "react";

import DarkModeOutlined from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlined from "@mui/icons-material/LightModeOutlined";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import { HamburgerMenu, RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";

import { ColorModeContext } from "../../providers/colorProvider";
import { UserMenu } from "./UserMenu";
import { LanguageSelect } from "./LanguageSelect";
import { SelectStore } from "../../pages/stores/select-stores/SelectStore";
import { OrderSearchBar } from "./components/OrderSearchBar";
import { getRuntimeEnv } from "../../providers/getRuntimeEnv";

type HeaderProps = RefineThemedLayoutV2HeaderProps & {
  showTitle?: boolean;
  showMarketplace?: boolean;
};

export const HeaderWithTitle: React.FC<HeaderProps> = (props: HeaderProps) => {
  return <Header {...props} showTitle showMarketplace={false} />;
};

export const HeaderWithTitleAndMarketplace: React.FC<HeaderProps> = (
  props: HeaderProps,
) => {
  return <Header {...props} showTitle />;
};

export const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { showTitle = false, sticky = false, showMarketplace = true } = props;
  const { mode, toggleMode } = useContext(ColorModeContext);
  const runtimeEnv = getRuntimeEnv();
  const isDevEnv = runtimeEnv === "dev";
  const title = isDevEnv ? "SyncroDev" : "Syncrosale";
  const logo = isDevEnv ? "/icons/logo-dev.svg" : "/icons/logo.svg";

  return (
    <AppBar position={sticky ? "sticky" : "relative"}>
      <Toolbar>
        {showTitle ? (
          <>
            <img
              src={logo}
              alt="App Icon"
              style={{ width: 48, height: 48, objectFit: "contain" }}
            />
            <Typography
              variant="h6"
              component="div"
              fontWeight={700}
              sx={{ marginLeft: 1 }}
            >
              {title}
            </Typography>
          </>
        ) : (
          <HamburgerMenu />
        )}

        {/* SEARCH BAR */}
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            mx: 3,
          }}
        >
          <OrderSearchBar />
        </Box>

        <Stack direction="row" justifyContent="flex-end" alignItems="center">
          <IconButton sx={{ mx: 2 }} color="inherit" onClick={toggleMode}>
            {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
          </IconButton>

          {showMarketplace && <SelectStore />}
          <LanguageSelect />
          <UserMenu />
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
